<template>
    <div>
        <hts-form-select
            v-model="cValue"
            v-model:text="cText"
            :label="$t('labels.workflow')"
            required
            :query="findCommodity"
            :disabled="disabled"
            :readonly="readonly"
            key-id="_id"
            key-label="fullName"
            :filterable="true"
            :clearable="true"
            :selected-multiple="dataSelectMultiple"
            :prop="prop"
            :color="props.color"
            :param-prepare="paramPrepare"
            @change="handleChange" />
    </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  modelValue: { type: [Array, String], default: () => '' },
  prop: { type: String, default: '' },
  nameSelect: { type: String, default: '' },
  multiple: { type: Boolean, default: false },
  dataMultiple: { type: [Array, Object], default: () => [] },
  required: { type: Boolean, default: false },
  name: { type: String, default: '' },
  label: { type: String, default: () => $t('labels.findPartner') },
  typeCooperator: { type: [String, Array], default: '' },
  creatable: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  readonly: { type: Boolean, default: false },
  transportation: { type: String, default: '' },
  dataSelectMultiple: { type: Array, default: () => [] },
  paramPrepare: { type: String, default: '' }
})
const emits = defineEmits(['update:modelValue', 'update:name', 'click', 'change'])

const { modelValue, name, transportation } = toRefs(props)

const cValue = computed({
  get () {
    return modelValue.value
  },
  set (val: any) {
    emits('update:modelValue', val)
  }
})
const handleChange = (val: any) => {
  emits('change', val)
}

const cText = computed({
  get () {
    return name.value || ''
  },
  set (val: any) {
    emits('update:name', val)
  }
})

const findCommodity = async (s: string) => {
  const api = $urlAdmin.workflow.find
  const res = await $api(api, { query: { key: s, transportation: transportation.value || '' } })
  const resData: any = res?.data.value
  if (resData?.success) {
    return resData.data
  }
  return null
}
</script>
